import { render, staticRenderFns } from "./CollectionPreview.vue?vue&type=template&id=43f76200&scoped=true"
import script from "./CollectionPreview.vue?vue&type=script&lang=js"
export * from "./CollectionPreview.vue?vue&type=script&lang=js"
import style0 from "./CollectionPreview.vue?vue&type=style&index=0&id=43f76200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f76200",
  null
  
)

export default component.exports